import { Component, OnDestroy, OnInit, Renderer2 } from "@angular/core";
import { BaseServiceService } from "src/app/services/base-service.service";
import { ModalNotifyTypes } from "../modal-notify/modal-notify.component";
import { HttpClient } from "@angular/common/http";
import { lastValueFrom } from "rxjs";
import { AppData } from "src/app/helpers/app-data";
import { FormBuilder, FormControl, FormGroup, Validators, AbstractControl } from '@angular/forms';

declare var fabric: any;

@Component({
  selector: "app-iniciar-proceso",
  templateUrl: "./iniciar-proceso.component.html",
  styleUrl: "./iniciar-proceso.component.css",
})
export class IniciarProcesoComponent implements OnInit, OnDestroy {
  botonProcesando = false;
  textoBotonProcesando = "Cargando...";
  initProcessForm: FormGroup;
  procesoObj: EjecucionProceso;

  constructor(
    private baseService: BaseServiceService,
    private renderer: Renderer2,
    private http: HttpClient,
    private _formBuilder:FormBuilder

  ) {
    this.procesoObj = new EjecucionProceso();
    this.formInit();
  }

  async ngOnInit(): Promise<void> {
    this.renderer.setStyle(document.body, "height", "100vh"); 

    //await this.getProcesos();
    //this.initializeFabric();

    var SpinnerElements = document.querySelectorAll(".ms-Spinner");
    for (var i = 0; i < SpinnerElements.length; i++) {
      new fabric["Spinner"](SpinnerElements[i]);
    }

  }
  ngOnDestroy(): void {
    this.renderer.removeStyle(document.body, 'height'); //  revertir al valor anterior
  }

  async getProcesos(): Promise<void> {
    const selectElement = document.querySelector(
      "#select-procesos"
    ) as HTMLSelectElement;
    selectElement.innerHTML = "<option>Seleccione&hellip;</option>"; 
    try {
      const response = await lastValueFrom(this.http.get<any>(AppData.API_URL+"Proceso/ListaProcesos"))
      const data = response.Data;
      data.forEach((element) => {
        const option = document.createElement("option");
        option.textContent = element.Nombre;
        option.value = element.Id;

        selectElement.appendChild(option);
      });
      
   /*    const responses = await this.baseService
        .getAll("Proceso/ListaProcesos")
        .toPromise();
      const data = response.Data;
      data.forEach((element) => {
        const option = document.createElement("option");
        option.textContent = element.Nombre;
        option.value = element.Id;

        selectElement.appendChild(option);
      }); */
    } catch (error) {}
  }

  initializeFabric(): void {
    // const DropdownHTMLElements = document.querySelectorAll(".ms-Dropdown");
    // for (let i = 0; i < DropdownHTMLElements.length; ++i) {
    //   new fabric["Dropdown"](DropdownHTMLElements[i]);
    // }

    var ButtonElements = document.querySelectorAll(".ms-Button");
    for (var i = 0; i < ButtonElements.length; i++) {
      new fabric["Button"]();
    }
  }

  formInit()
  {
    this.initProcessForm = this._formBuilder.group({
      idProceso: new FormControl(null, [Validators.required])
    });
  }

  async createEjecucionProceso(): Promise<void> {
    // const selectElement = document.querySelector(
    //   ".ms-Dropdown-select"
    // ) as HTMLSelectElement;
    this.botonProcesando = true;
    this.procesoObj.IdProceso = Number(this.initProcessForm.get('idProceso').value);
    
    //this.procesoObj.FechaInicia = new Date();    

    try {
      const response = await this.baseService.create(
        "EjecucionProceso/CrearEjecucionProceso",
        this.procesoObj
      );  

      if (!response.Ok) {
        let mensajeError = "<ul>";
        response.ValidationErrors.forEach((error: any) => {
          mensajeError += `<li>${error}</li>`;
        });
        mensajeError += "</ul>";

        this.baseService.triggerShowModal(
          "Error al ejecutar proceso",
          mensajeError,
          ModalNotifyTypes.Danger,
          false
        );
        this.botonProcesando = false;
      } else {
        this.baseService.triggerShowModal(
          "Proceso Ejecutado",
          "Proceso Ejecutado correctamente ",
          ModalNotifyTypes.Success,
          false
        );
        this.botonProcesando = false;
      }
    } catch (error) {

      let mensajeError = error.error.Error;
      
      this.baseService.triggerShowModal(
        "Error",
        mensajeError,
        ModalNotifyTypes.Danger,
        false
      );
      this.botonProcesando = false;
    }
  }
}

export class EjecucionProceso {
  IdProceso: number;
  //FechaInicia: Date;

  constructor() {
    this.IdProceso = null;
   // this.FechaInicia = null;
  }
}
